'use strict';

/**
 *
 * @name: MastheadConfig
 *
 */

import MastheadTemplate from './masthead.index.html';

function MastheadConfig($stateProvider) {

  'ngInject';

  $stateProvider
    .state('main.masthead', {
      url: 'masthead',
      template: MastheadTemplate,
      controller: 'MastheadController',
      resolve: {
        resolvedMasthead: function($rootScope, $q, apiMastheadService) {

          var deferred = $q.defer();

          apiMastheadService.get()
            .success(function(res){
              deferred.resolve(res);
            });

          return deferred.promise;
        }
      }
    });

}

export default MastheadConfig;



// WEBPACK FOOTER //
// ./app/pages/masthead/masthead.config.js